import AuthorizeOryService from "./AuthorizeOryService";

export default AuthorizeOryService